function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCapture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "ion:camera"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 766",
    cx: 30,
    cy: 30,
    r: 29,
    fill: "#FC5A5A",
    stroke: "#FC5A5A",
    style: {
      fill: "#FC5A5A",
      fill: "color(display-p3 0.9882 0.3529 0.3529)",
      fillOpacity: 1,
      stroke: "#FC5A5A",
      stroke: "color(display-p3 0.9882 0.3529 0.3529)",
      strokeOpacity: 1
    },
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30 36.125C32.7614 36.125 35 33.8864 35 31.125C35 28.3636 32.7614 26.125 30 26.125C27.2386 26.125 25 28.3636 25 31.125C25 33.8864 27.2386 36.125 30 36.125Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M42.375 22.125H38.2266C38.0156 22.125 37.7541 21.9886 37.5502 21.7734L35.7262 18.8948C35.6974 18.8492 35.6652 18.8057 35.6299 18.7648C34.9999 18.03 34.1484 17.625 33.2344 17.625H26.7656C25.8516 17.625 25.0001 18.03 24.3701 18.7648C24.3348 18.8057 24.3026 18.8492 24.2738 18.8948L22.4498 21.7777C22.2937 21.9478 22.0744 22.1292 21.8438 22.1292V21.5667C21.8438 21.2684 21.7252 20.9822 21.5142 20.7712C21.3033 20.5602 21.0171 20.4417 20.7188 20.4417H19.0312C18.7329 20.4417 18.4467 20.5602 18.2358 20.7712C18.0248 20.9822 17.9062 21.2684 17.9062 21.5667V22.1292H17.625C16.7302 22.1301 15.8723 22.486 15.2395 23.1188C14.6068 23.7515 14.2509 24.6094 14.25 25.5042V39C14.2509 39.8948 14.6068 40.7527 15.2395 41.3855C15.8723 42.0182 16.7302 42.3741 17.625 42.375H42.375C43.2698 42.3741 44.1277 42.0182 44.7605 41.3855C45.3932 40.7527 45.7491 39.8948 45.75 39V25.5C45.7491 24.6052 45.3932 23.7473 44.7605 23.1145C44.1277 22.4818 43.2698 22.1259 42.375 22.125ZM30 37.875C28.665 37.875 27.3599 37.4791 26.2499 36.7374C25.1399 35.9957 24.2747 34.9415 23.7638 33.7081C23.2529 32.4747 23.1192 31.1175 23.3797 29.8081C23.6402 28.4988 24.283 27.296 25.227 26.352C26.171 25.408 27.3738 24.7652 28.6831 24.5047C29.9925 24.2442 31.3497 24.3779 32.5831 24.8888C33.8165 25.3997 34.8707 26.2649 35.6124 27.3749C36.3541 28.4849 36.75 29.79 36.75 31.125C36.748 32.9146 36.0361 34.6303 34.7707 35.8957C33.5053 37.1611 31.7896 37.873 30 37.875Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapture);
export default __webpack_public_path__ + "static/media/capture.a48887e5d9deb6831a26e013d7b8dd00.svg";
export { ForwardRef as ReactComponent };